export enum TargetPersonSelectionState {
  Confirmed = 'confirmed',
  Ignored = 'ignored',
}
